import { Get } from "@/services/api/utilities-api";
import { companyDataResponse } from "@/models/equip-api-response-objects/companyDataResponse";
import { excelCompanyDataRequest } from "@/models/excel-udf-request-objects/excelCompanyDataRequest";
import { excelCompanyDataInfoRequest } from "@/models/excel-udf-request-objects/excelCompanyDataInfoRequest";
import { groupBuilderResponse } from "@/models/equip-api-response-objects/groupBuilderResponse";

export function GetCompanyInfo(dataRequest: excelCompanyDataInfoRequest): Promise<companyDataResponse> {
  return Get<companyDataResponse>("/company/companydatainfo", {
    companygroup: dataRequest.companygroup,
    formula: dataRequest.formula,
    asof: dataRequest.asof,
    datacontext: dataRequest.datacontext,
    offsetfromutc: dataRequest.offsetfromutc,
  });
}

export function GetCompanyData(dataRequest: excelCompanyDataRequest): Promise<companyDataResponse> {
  return Get<companyDataResponse>("/company/companydata", {
    companygroup: dataRequest.companygroup,
    formula: dataRequest.formula,
    asof: dataRequest.asof,
    currency: dataRequest.currency,
    datacontext: dataRequest.datacontext,
    year: dataRequest.yearOrRollingPeriod > 60 ? dataRequest.yearOrRollingPeriod : undefined,
    endperiod: dataRequest.endperiod,
    periodtype: dataRequest.periodtype,
    fxdate: dataRequest.fxdate,
    pricedate: dataRequest.pricedate,
    rollingperiod: dataRequest.yearOrRollingPeriod <= 60 ? dataRequest.yearOrRollingPeriod : undefined,
    offsetfromutc: dataRequest.offsetfromutc,
  });
}

export function GetCompanyGroupData(group:string, datacontext: string = 'LIVE'): Promise<groupBuilderResponse>{
  return Get<groupBuilderResponse>("company/groupbuilder",{
    group: group,
    datacontext : datacontext
  })
}